import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IRIQModal } from 'src/app/models/IModal';
import { DisputeTrackerService } from '../dispute-tracker.service';
import { ConsumerDispute, ConsumerDisputeNote } from '../models/consumerDispute';
import { ToastrService } from 'ngx-toastr';
import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { FilteringService } from 'src/app/services/filtering.service';
import { AuthService } from 'src/app/services/auth.service';
import { ScreeningLight } from 'src/app/models/screeningInvite';
import { RiqAlertComponent } from 'src/app/shared-components-module/riq-alert/riq-alert.component';

@Component({
  selector: 'app-dispute-modal',
  templateUrl: './dispute-modal.component.html',
  styleUrls: ['./dispute-modal.component.less']
})
export class DisputeModalComponent implements OnInit, IRIQModal, OnDestroy {
  
  @Input() screeningId: number;
  @Input() reportNumber: number;
  @Input() disputedScreening: ScreeningLight;
  @Input() existingDispute: ConsumerDispute;

  public get newDispute(): boolean {
    if(this.existingDispute) return false;
    return true;
  }

  public get canSendDisputeEmails(): boolean {
    if(this.auth.UserInRole('DisputeManager')) return true;
    return false;
  }

  private $saveSub: Subscription;
  private $fetchSub: Subscription;
  private $resolveSub: Subscription;

  newDispo: ConsumerDispute;
  dispoNote: ConsumerDisputeNote;

  constructor(private modalService: NgbModal, private disputeService: DisputeTrackerService, private toast: ToastrService, public filtering: FilteringService, public auth: AuthService) 
  {
      
    
  }


  ngOnDestroy(): void {
    if(this.$saveSub) this.$saveSub.unsubscribe();
    if(this.$fetchSub) this.$fetchSub.unsubscribe();
    if(this.$resolveSub) this.$resolveSub.unsubscribe();
  }
  
  save(): void {
    this.newDispo.screeningId = this.screeningId;
    this.newDispo.reportNumber = this.disputedScreening.invitationId;
    if(this.dispoNote.note) {
      this.newDispo.disputeNotes = [];
      this.newDispo.disputeNotes.push(this.dispoNote)
    };
    this.$saveSub = this.disputeService.saveConsumerDispute(this.newDispo).pipe(
      tap(
        _ => {
          this.toast.success(`Dispute started for report: ${this.reportNumber}`);
          this.disputedScreening.isDisputedScreening = true;
          this.disputedScreening.hasDispute = true; // Update hasDispute to change button text
          this.cancel();
        },
        err => {
          this.toast.error('Error beginning dispute process.', '', { closeButton: true, disableTimeOut: true })
        },
        () => {

        }
      )
    ).subscribe();
  }

  saveNote(): void {
    if(this.newDispute) return; //just in case
    this.dispoNote.disputeId = this.existingDispute.id;
    this.$saveSub = this.disputeService.saveConsumerDisputeNote(this.dispoNote).pipe(
      tap(_ => {
        this.toast.success('Dispute note saved!', '');
        if(!this.existingDispute.disputeNotes) this.existingDispute.disputeNotes = [];
        this.existingDispute.disputeNotes.push(this.dispoNote);
        this.dispoNote = new ConsumerDisputeNote();
      },
      err => {
        this.toast.error('Error saving dispute note!', '', { closeButton: true, disableTimeOut: true });
      },
      () => {

      }
    )).subscribe();
  }

  cancel(): void {
    this.modalService.dismissAll();
  }
  ngOnInit(): void {

    console.log('DISPO SCREENING: ', this.disputedScreening)
    this.dispoNote = new ConsumerDisputeNote();
    if(this.existingDispute) {
      this.$fetchSub = this.disputeService.getConsumerDisclosureNotes(this.existingDispute.id).pipe(
        tap(_ => {
          this.existingDispute.disputeNotes = _;
        },
        err => {
          this.toast.error('Error fetching dispute notes!', '', { closeButton: true, disableTimeOut: true })
        },
        () => {

        })
      ).subscribe();
    }
    else {
      this.newDispo = new ConsumerDispute();
      //prefill the stuff that needs to be verified
      this.newDispo.confirmedFirstName = this.disputedScreening.applicantFirstName;
      this.newDispo.confirmedLastName = this.disputedScreening.applicantLastName;
      this.newDispo.confirmedAddress = this.disputedScreening.applicantStreet;
      this.newDispo.confirmedCity = this.disputedScreening.applicantCity;
      this.newDispo.confirmedState = this.disputedScreening.applicantState;
      this.newDispo.confirmedZip = this.disputedScreening.applicantZipCode;
      this.newDispo.confirmedPhone = this.disputedScreening.applicantPhone;
      this.newDispo.confirmedEmail = this.disputedScreening.applicantEmail;
    }
  }

  resolveDispute() {
    if(!this.existingDispute.resolutionNote) {
      this.toast.info('Please provide a dispute resolution note.');
      return;
    }
    if(this.newDispute || !this.existingDispute) return;
    this.$resolveSub = this.disputeService.resolveConsumerDispute(this.existingDispute).pipe(
      tap(
        _ => {
          this.toast.success('Dispute reolved!');
          this.existingDispute.isResolved = true;
          //temp sub the data in
          this.existingDispute.resolvingUserName = this.auth.loggedInUser.userName;
          this.existingDispute.dateResolved = new Date();
          this.modalService.dismissAll();
        },
        err => {
          this.toast.error('Error resolving dispute', '', { closeButton: true, disableTimeOut: true });
        },
        () => {
        }
      )
    ).subscribe();
  }

  reactivateDispute() {
    if(this.newDispute || !this.existingDispute || !this.existingDispute.isResolved) return;
    
    this.$resolveSub = this.disputeService.reactivateConsumerDispute(this.existingDispute.id).pipe(
      tap(
        _ => {
          this.toast.success('Dispute reactivated successfully!');
          this.existingDispute.isResolved = false;
          this.existingDispute.resolutionNote = null;
          this.existingDispute.resolvingUserName = null;
          this.existingDispute.dateResolved = null;
          // Update the screening's dispute status if available
          if(this.disputedScreening) {
            this.disputedScreening.hasDispute = true;
          }
        },
        err => {
          this.toast.error('Error reactivating dispute', '', { closeButton: true, disableTimeOut: true });
        },
        () => {
        }
      )
    ).subscribe();
  }

  sendDisputePropertyEmail() {
    let modal = this.modalService.open(RiqAlertComponent, { size: 'lg' });
    modal.componentInstance.name = 'AYS_SendDisputeEmail_Property';
    modal.componentInstance.title = 'Send Disclosure Email - Property?';
    modal.componentInstance.alertBody = 'This will email the property the dispute started email. Please confirm:';
    modal.componentInstance.cancelButtonText = 'Cancel';
    modal.componentInstance.confirmButtonText = 'Send';

    modal.componentInstance.evnt.subscribe((ev)=>{
      this.disputeService.sendDisputeEmailProperty(this.reportNumber).pipe(
        tap(() => { this.toast.success('Sending dispute email - property.'); },
        err => { this.toast.error('Error sending dispute email!', '', { closeButton: true, disableTimeOut: true }) },
        () => {
          this.modalService.dismissAll();
        })
      ).subscribe();
    });
  }

  sendDisputeApplicantEmail() {
    let modal = this.modalService.open(RiqAlertComponent, { size: 'lg' });
    modal.componentInstance.name = 'AYS_SendDisputeEmail_Applicant';
    modal.componentInstance.title = 'Send Disclosure Email - Applicant?';
    modal.componentInstance.alertBody = 'This will email the applicant the dispute started email. Please confirm:';
    modal.componentInstance.cancelButtonText = 'Cancel';
    modal.componentInstance.confirmButtonText = 'Send';

    modal.componentInstance.evnt.subscribe((ev)=>{
      this.disputeService.sendDisputeEmailApplicant(this.reportNumber).pipe(
        tap(() => { this.toast.success('Sending dispute email - applicant'); },
        err => { this.toast.error('Error sending dispute email!', '', { closeButton: true, disableTimeOut: true }) },
        () => {
          this.modalService.dismissAll();
        })
      ).subscribe();
    });
  }

}
